
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"48","height":"49","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.5 43.61h13M14.757 31.424A14.973 14.973 0 019 19.694c-.045-8.13 6.51-14.889 14.638-15.08a15 15 0 019.627 26.793A4.554 4.554 0 0031.5 34.98v1.13a1.5 1.5 0 01-1.5 1.5H18a1.5 1.5 0 01-1.5-1.5v-1.131a4.52 4.52 0 00-1.743-3.555v0z","stroke":"#000C1F","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M25.523 10.757a8.986 8.986 0 017.351 7.341","stroke":"#3DAFB8","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    